(() => {
  'use strict';
  const host = document.getElementById('xo-safety-store-chat');
  if (!host || host.dataset.wired) return;
  host.dataset.wired = 'true';
  const frame = host.querySelector('iframe');
  const chatOrigin = 'https://xo-safety-chat-preview.onrender.com';
  const storeOrigins = ['https://www.xosafety.com', 'https://xosafety.com'];
  if (!storeOrigins.includes(location.origin)) { host.remove(); return; }
  function shareContext() {
    frame.contentWindow.postMessage({type: 'xo-chat-host', mobile: matchMedia('(max-width:600px)').matches}, chatOrigin);
    const page = new URL(location.href);
    let context = null;
    if (/^\/(?:$|(?:products|collections|pages|blogs)(?:\/|$))/.test(page.pathname)) {
      page.search = ''; page.hash = '';
      context = {url: page.href, title: document.title.slice(0, 200)};
    }
    frame.contentWindow.postMessage({type: 'xo-store-page', page: context}, chatOrigin);
  }
  frame.addEventListener('load', shareContext);
  window.addEventListener('message', event => {
    if (event.source !== frame.contentWindow || event.origin !== chatOrigin) return;
    if (event.data?.type === 'xo-chat-ready') shareContext();
    else if (event.data?.type === 'xo-chat-state' && typeof event.data.open === 'boolean') host.dataset.open = String(event.data.open);
  });
  window.addEventListener('resize', shareContext);
  window.addEventListener('popstate', shareContext);
})();
